// src/components/Content.js
import React from "react";

const Content = ({ children, isSidebarCollapsed, marginClass }) => {
  return <div className={`w-full bg-white ${marginClass}`}>{children}</div>;
};

export default Content;
